import { currencyColumn, dateColumn, polymorphicColumn } from "./columnHelpers";
import { ownerEndpoints } from "@utils/morphTypes";

export const salesRelationship = {
    collapsible: true,
    title: 'Sales',
    tint: 'default',
    type: 'table',
    sort: ['date', 'desc'],
    columns: [
        dateColumn({label: 'Sale Date', width: '30%'}),
        currencyColumn({width: '30%'}),
        polymorphicColumn({
            label: 'Former Owner',
            column: 'former_owner_id',
            typeColumn: 'former_owner_type',
            relationship: 'former_owner',
            endpoints: ownerEndpoints,
            width: '40%',
        }),
    ],
    newRowData: ({object}) => {
        if(!object?.owner_id || !object?.owner_type) {
            return {};
        }

        return {
            former_owner_id: object.owner_id,
            former_owner_type: object.owner_type,
            former_owner: object.owner ?? null,
        };
    },
};